import { Pipe, PipeTransform } from "@angular/core";

export interface ItemWithIndexedDate {
    year: number;
    month?: number;
    [key: string]: any;
}

@Pipe({
    name: "asTrendDate",
    standalone: true,
})
export class SharedTrendDatePipe implements PipeTransform {
    transform(item: ItemWithIndexedDate): Date {
        const month = (item.month ?? 1) - 1;
        return new Date(item.year, month);
    }
}
